import React from "react";
import { connect } from "react-redux";
import Modal from "@components/modal";
import { IconContainer, Title, NcbContent } from "./styles";
import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import {
  getNcb,
  EXPIRED_POLICY_STATUS_90_DAYS,
  getWidgetSpecificIsVisible
} from "@utils/index";
import ImageContainer from "@components/imageContainer";
import { isEmpty } from "@utils/lodash";
import { resolvePath } from "@utils/resolvePath";
import DOMPurify from "isomorphic-dompurify";
import { useOnload } from "@utils/useOnLoad";

interface IContent {
  title: string;
  ncbContent: "";
  image: {
    imgSrc: "";
    height: 64;
    width: 66;
    alt: "icon";
  };
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const NcbUpdateModal = ({
  is_visible,
  previousNcb,
  newNcb,
  policyStatus,
  previousAddons,
  content,
  actions,
  hideCloseButton = true,
  lockBackgroundInteraction = true
}: {
  setShowModal: Function;
  is_visible: boolean;
  previousNcb?: string | number | null;
  newNcb: string | number;
  policyStatus: string | null;
  previousAddons?: any;
  content: {
    ncbProtect?: IContent;
    ncbIncrease: IContent;
    ncbMax: IContent;
    ncbResetPolicyExpired: IContent;
    ncbResetPreviousPolicyClaim: IContent;
  };
  actions: any;
  hideCloseButton: boolean,
  lockBackgroundInteraction?: boolean;
}) => {
  if (previousNcb === null || previousNcb === undefined) {
    return <></>;
  }
  const new_ncb = getNcb(newNcb);
  const previous_ncb = getNcb(previousNcb);

  const newNcbValue = new_ncb?.value;
  const previousNcbValue = previous_ncb?.value;

  const isNcbProtectAddonPresentinPreviousPolicy =
    !!previousAddons &&
    previousAddons?.length > 0 &&
    !isEmpty(
      previousAddons.find((prevAddon) => prevAddon?.id === "ncb_protect_car")
    );

  const { on_modal_close, on_load } = actions || {};

  useOnload({ on_load, is_visible });

  const getNcbModalContent = () => {
    let ncbContent = {
      title: "",
      ncbContent: "",
      image: {
        imgSrc: "",
        height: 64,
        width: 66,
        alt: "icon"
      }
    };

    if (newNcbValue > 0 && newNcbValue <= 50) {
      if (newNcbValue === previousNcbValue) {
        if (isNcbProtectAddonPresentinPreviousPolicy) {
          // if user opted for NCB protect addon

          ncbContent = { ...ncbContent, ...content.ncbProtect };
        } else if (newNcbValue === 50) {
          // if previos ncb = new ncb = 50
          ncbContent = { ...content.ncbMax };
        }
      } else if (newNcbValue > previousNcbValue) {
        ncbContent = { ...content.ncbIncrease };
      }
    }
    // new ncb = 0
    else {
      if (policyStatus === EXPIRED_POLICY_STATUS_90_DAYS) {
        ncbContent = { ...content.ncbResetPolicyExpired };
      } else {
        // not explicitly checking the claim status because new Ncb can be zero only in 2 cases
        ncbContent = { ...content.ncbResetPreviousPolicyClaim };
      }
    }

    return ncbContent;
  };

  const { title, ncbContent, image } = getNcbModalContent();

  const handleClose = () => {
    if (on_modal_close?.length > 0) {
      on_modal_close?.forEach((eachFunc: any) => {
        typeof eachFunc.funCall === "function" &&
          eachFunc.funCall(eachFunc.args);
      });
    }
  };

  return (
    <Modal
      showModal={is_visible}
      styles={{ maxWidth: "500px" }}
      hideCloseButton={hideCloseButton}
      lockBackgroundInteraction={lockBackgroundInteraction}
      is_visible={is_visible}
      headerStyles={{ marginBottom: "-2rem" }}
      onClose={() => {
        handleClose();
      }}
    >
      <>
        <Flex flexDirection="column">
          <IconContainer>
            {!isEmpty(image) && image?.imgSrc ? (
              <ImageContainer
                imgSrc={image?.imgSrc}
                height={image?.height}
                width={image?.width}
                alt={image?.alt}
              />
            ) : (
              <ImageContainer
                imgSrc={resolvePath("/images/icons/gift-icon.svg")}
                height={64}
                width={64}
                alt={"icon"}
              />
            )}
          </IconContainer>
          <Title
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(title)
            }}
          />
          <NcbContent
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(ncbContent)
            }}
          />
          <Box style={{ marginTop: "2rem" }}>
            <PrimaryButton
              isFullWidth
              onClick={() => {
                handleClose();
              }}
            >
              OK
            </PrimaryButton>
          </Box>
        </Flex>
      </>
    </Modal>
  );
};

export default connect(mapStateToProps)(NcbUpdateModal);
